import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const BusinessResultsRoot = superstyled({
  name: 'BusinessResults',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    border: `1px solid ${theme.palette.border.main}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius
  })
});

export const IdeasHeader = superstyled({
  name: 'BusinessResults',
  slot: 'IdeasHeader',
  tag: Box,
  styles: () => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'column'
  })
});

export const IdeasContent = superstyled({
  name: 'BusinessResults',
  slot: 'IdeasContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '1',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })
});

export const IdeasSidebar = superstyled({
  name: 'BusinessResults',
  slot: 'IdeasSidebar',
  tag: Box,
  styles: ({ theme }) => ({
    flex: '0 0 20rem',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,

    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
      flex: 'none',
      minHeight: '200px'
    }
  })
});

export const MainContent = superstyled({
  name: 'BusinessResults',
  slot: 'MainContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden'
  })
});

export const SidebarHeader = superstyled({
  name: 'BusinessResults',
  slot: 'SidebarHeader',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.border.main}`
  })
});

export const SidebarTitle = superstyled({
  name: 'BusinessResults',
  slot: 'SidebarTitle',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(1)
  })
});

export const SidebarSubtitle = superstyled({
  name: 'BusinessResults',
  slot: 'SidebarSubtitle',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const IdeasList = superstyled({
  name: 'BusinessResults',
  slot: 'IdeasList',
  tag: Box,
  styles: () => ({
    overflow: 'auto'
  })
});

export const ButtonsContainer = superstyled({
  name: 'BusinessResults',
  slot: 'ButtonsContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});

export const ContentHeader = superstyled({
  name: 'BusinessResults',
  slot: 'ContentHeader',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    padding: theme.spacing(3, 3, 0, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5, 1.5, 0, 1.5)
    }
  })
});

export const ContentSubHeader = superstyled({
  name: 'BusinessResults',
  slot: 'ContentSubHeader',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing(2),
      padding: theme.spacing(1, 0)
    }
  })
});

export const ContentHeaderTitle = superstyled({
  name: 'BusinessResults',
  slot: 'ContentHeaderTitle',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const ContentTitle = superstyled({
  name: 'BusinessResults',
  slot: 'ContentTitle',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary
  })
});

export const ContentBody = superstyled({
  name: 'BusinessResults',
  slot: 'ContentBody',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5)
    }
  })
});

export const DownloadButton = superstyled({
  name: 'BusinessResults',
  slot: 'DownloadButton',
  tag: Button,
  styles: ({ theme }) => ({
    alignSelf: 'center',
    padding: theme.spacing(1.5, 2)
  })
});

export const FooterSectionContent = superstyled({
  name: 'ReportSection',
  slot: 'FooterContent',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(0),
      marginTop: theme.spacing(2)
    }
  })
});
